var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "saved-product-container" }, [
    _c(
      "div",
      { staticClass: "item-image" },
      [
        _c("spinner", { attrs: { show: _vm.isImageLoading } }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "images-loaded",
              rawName: "v-images-loaded",
              value: _vm.imageLoaded,
              expression: "imageLoaded"
            }
          ],
          key: _vm.productColorImage.id,
          class: { image: true, "image--loading": _vm.isImageLoading },
          attrs: { src: _vm.productColorImage.url }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "item-info" },
      [
        _c("div", { staticClass: "item-brand" }, [
          _vm.currentProduct.product_brand_title
            ? _c("span", [
                _vm._v(_vm._s(_vm.currentProduct.product_brand_title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("a", {
            staticClass: "cross",
            on: {
              click: function($event) {
                return _vm.$emit("unsave", _vm.currentProduct)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item-name",
            class: { noBrand: !_vm.currentProduct.product_brand_title }
          },
          [_vm._v(_vm._s(_vm.currentProduct.product_title))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "item-price" }, [
          _vm._v(_vm._s(_vm._f("currency")(_vm.currentProduct.product_price)))
        ]),
        _vm._v(" "),
        _c("color-size-selector", {
          ref: "colorSizeSelector",
          attrs: {
            colors: _vm.currentProduct.product_colors,
            sizes: _vm.sortedSizes,
            selectedColorId: _vm.selectedColorId,
            selectedSizeId: _vm.selectedSizeId,
            isPristine: _vm.currentProduct.isPristine,
            showValidation: true
          },
          on: {
            "color-changed": _vm.colorChanged,
            "size-changed": _vm.sizeChanged
          }
        }),
        _vm._v(" "),
        _vm.isVariantOOS || _vm.isProductOOS
          ? [
              _c("swap-item-button", {
                attrs: {
                  classes: "add-to-cart-btn oos swap",
                  text: "SWAP",
                  icon: "white"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("requested-swap", _vm.currentProduct)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "add-to-cart-btn oos",
                  attrs: { disabled: true }
                },
                [_vm._v("\n                OUT OF STOCK\n            ")]
              )
            ]
          : [
              _c(
                "button",
                {
                  staticClass: "add-to-cart-btn",
                  class: {
                    "add-to-cart-btn--disabled":
                      !_vm.selectedColorId || !_vm.selectedSizeId
                  },
                  on: { click: _vm.addProductToCart }
                },
                [_vm._v("Move to cart")]
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ed0f408", { render: render, staticRenderFns: staticRenderFns })
  }
}